import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'
import isPropValid from '@emotion/is-prop-valid'
import { Box } from '@mui/material'

export const MobileHeaderContainer = styled(Box, {
  shouldForwardProp: titleColour => isPropValid(titleColour),
})<CmsProps>`
  h1,
  h2,
  h3,
  h4 {
    text-align: center;
    color: ${({ titleColour }) => titleColour || '#FFF'};
    margin-top: 0.67em;
    margin-bottom: 0.67em;
  }

  p {
    text-align: center;
    color: ${({ titleColour }) => titleColour || '#FFF'};
    position: relative;
    margin-top: 1em;
    margin-bottom: 1em;
  }
`

export const GradientContainer = styled(Box, {
  shouldForwardProp: headerColor => isPropValid(headerColor),
})<CmsProps>`
  background: ${({ headerColor }) => headerColor};
  height: ${({ gradientHeight }) => gradientHeight};
  width: 100%;

  h1,
  h2,
  h3,
  h4,
  p {
    z-index: 2;
    position: relative;
  }
`
